import React, { Component } from "react";
import { Tabs } from "antd";
import Bi from "./bi";
import Hr from "./hr";
import It from "./it";
import Training from "./training";
import "../faqs/style.css";
import Operations from "./operations";
import Banner from "./payout";
import Instructions from './generalInstructions';
import { FAQs } from "../../../json/testDB";

const { TabPane } = Tabs;

class Mission extends Component {
  state = {
    tabPosition: "left",
  };
  changeTabPosition = (e) => {
    this.setState({ tabPosition: e.target.value });
  };

  render() {
    const { tabPosition } = this.state;
    return (
      <div className="faqsContainer animate__animated animate__fadeIn">
        <div className="tabhead2">
          <h2 className="tabtext">FAQS</h2>
          <input
            type="search"
            placeholder="Type your Question..."
            className="searchtab"
          ></input>
        </div>

        <Tabs className="faqTab" tabPosition={tabPosition}>
          <TabPane tab="Human Resources (HR)" key="1">
            <Hr payload={FAQs.hrData} />
          </TabPane>
          <TabPane tab="Business Resources (BI)" key="2">
            <Bi payload={FAQs.biData} />
          </TabPane>
          <TabPane tab="Operations" key="3">
            <Operations payload={FAQs.operationsData} />
          </TabPane>
          <TabPane tab="Training" key="4">
            <Training payload={FAQs.trainingData} />
          </TabPane>
          <TabPane tab="Information Technology (IT)" key="5">
            <It payload={FAQs.itData} />
          </TabPane>
          <TabPane tab="Payout" key="6">
            <Banner />
          </TabPane>
          <TabPane tab="General Instructions" key="7">
          <Instructions payload={FAQs.InstructionsData} />
         
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default Mission;

